<template>
  <b-modal
    id="send-instruction-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.sendInstruction')"
    :cancel-title="$t('button.close')"
    centered
    :title="$t('general.sendInstruction')"
  >
    <validation-observer ref="sendInstructionForm" #default="{ invalid }">
      <!-- form -->
      <n-form-confirmation
        ref="formConfirmation"
        key="sendInstructionForm"
        :form="$refs.sendInstructionForm"
        :disabled="invalid"
        @submit="submit"
      >
        <n-input :fields="formInput" v-model="data"></n-input>
      </n-form-confirmation>
    </validation-observer>

    <template v-if="isValidEmail" #modal-ok :disabled="loading || invalid">
      <b-spinner small label="Spinning" v-if="loading"></b-spinner>
      <span v-else>{{ $t("button.sendInstruction") }}</span>
    </template>
    <template #modal-footer>
      <button type="button" class="btn btn-outline-secondary" @click="hide">
        {{ $t("button.close") }}
      </button>
      <button
        ref="sendInstructionButton"
        type="button"
        class="btn btn-primary"
        :disabled="!isValidEmail"
        @click="handleSubmit"
      >
        {{ $t("button.sendInstruction") }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BSpinner } from "bootstrap-vue";
import FormInput from "./sendInstuctionFormInput";
import NInput from "@/components/NInput";
import Repository from "@/repositories/RepositoryFactory";
import NFormConfirmation from "@/components/NFormConfirmation";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const IntegrationRepository = Repository.get("integration");

export default {
  components: {
    BModal,
    BSpinner,
    NFormConfirmation,
    NInput,
  },
  data() {
    return {
      loading: false,
      data: {
        email: "",
      },
    };
  },
  computed: {
    isValidEmail() {
      const { email } = this.data;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
  },
  mounted() {
    console.log(this.data);
  },
  methods: {
    show() {
      this.data.email = "";
      this.$bvModal.show("send-instruction-modal");
    },
    hide() {
      this.data.email = "";
      this.$bvModal.hide("send-instruction-modal");
    },
    handleSubmit() {
      this.invalid = false;
      this.$refs.sendInstructionForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          IntegrationRepository.sendInstruction(this.data)
            .then((response) => {
              this.hide();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: this.$t("alert.success"),
                  icon: "CheckCircleIcon",
                },
              });
            })
            .catch((error) => {
              if (error.response?.status == 422) {
                this.$refs.sendInstructionForm.setErrors(
                  error.response?.data?.validate
                );
              }
            })
            .then(() => {
              this.loading = false;
            });
        }
      });
    },
  },

  setup() {
    const formInput = [...FormInput];

    return {
      formInput,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
